import path from 'ramda/src/path'
import moduleDescriptions from 'root/src/shared/descriptions/modules'

export default (state, props) => {
	const { moduleId, moduleKey, fieldDescPath } = props

	const field = path(
		[moduleId, ...fieldDescPath],
		moduleDescriptions,
	)

	const fieldMod = typeof field === 'function' ? field(state, props) : field

	const formData = path(
		['form', moduleKey, 'formInputs'],
		state,
	)

	return items => fieldMod?.modifyOptions?.(items, { formData, state })
}
